import { AutocompleteInput, NumberInput, ReferenceInput, TextInput, maxLength, minValue, required } from "react-admin";
import { Grid } from "@mui/material";
import { specialistRequests } from "api/specialistApi";

const EditForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="specializationId"
          reference={specialistRequests.getSpecializationsSelect()}
        >
          <AutocompleteInput
            optionText="nameBg"
            label="Специалност"
            fullWidth
            validate={[required()]}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="name"
          label="Име на изпитна комисия"
          validate={[required(), maxLength(300)]}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <NumberInput
          source="year"
          label="Година"
          validate={[required(), minValue(2025)]}
          onWheel={e => e.target.blur()}
        />
      </Grid>
    </Grid>
  );
};

export default EditForm;
